import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import Select from 'react-select'
import { useForm } from 'react-hook-form'
import { Table, Button } from 'react-bootstrap'
import axios from 'axios'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import html2PDF from 'html2pdf.js'
import apiService from '../../Components/services/apiService'
import '../../Components/pdfstyle.css' // Import your external CSS file
import DataTable from 'datatables.net-dt'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import StatusToggle from '../ui/StatusToggle'
import ConfirmModal from '../ui/ConfirmModal'
import { format } from 'date-fns'
import {
  EditIcon,
  DeleteIcon,
  TaskIcon,
  ExportIcon,
  ImportIcon,
  TaskSquareIcon,
} from '../Icons'
import AddTest from './AddTest'
import EditTest from './EditTest'

// Skeleton loading component
const TableSkeleton = () => (
  <div className="animate-pulse">
    <table className="w-full">
      <thead className="bg-neutral-50">
        <tr>
          <th className="text-sm text-[#535862] font-medium text-center border w-[100px] px-5 py-3.5 border-[#F0F0F0]">
            S.No
          </th>
          <th className="text-sm text-[#535862] font-medium text-center border w-40 px-5 py-3.5 border-[#F0F0F0]">
            Test Code
          </th>
          <th className="text-sm text-[#535862] font-medium text-center border w-96 px-5 py-3.5 border-[#F0F0F0]">
            Test Name
          </th>
          <th className="text-sm text-[#535862] font-medium text-center border w-40 px-5 py-3.5 border-[#F0F0F0]">
            Dates
          </th>
          <th className="text-sm text-[#535862] font-medium text-center border w-32 px-5 py-3.5 border-[#F0F0F0]">
            Status
          </th>
          <th className="text-sm text-[#535862] font-medium text-center border w-32 px-5 py-3.5 border-[#F0F0F0]">
            Actions
          </th>
        </tr>
      </thead>
      <tbody>
        {[...Array(5)].map((_, index) => (
          <tr key={index} className="border border-[#F0F0F0]">
            <td className="text-center border px-5 py-2 border-[#F0F0F0]">
              <div className="h-4 bg-gray-200 rounded w-8 mx-auto"></div>
            </td>
            <td className="border px-5 py-2 border-[#F0F0F0]">
              <div className="h-4 bg-gray-200 rounded w-20 mx-auto"></div>
            </td>
            <td className="border px-5 py-2 border-[#F0F0F0]">
              <div className="h-4 bg-gray-200 rounded w-32 mx-auto"></div>
            </td>
            <td className="border px-5 py-2 border-[#F0F0F0]">
              <div className="h-4 bg-gray-200 rounded w-20 mx-auto"></div>
            </td>
            <td className="text-center border px-5 py-2 border-[#F0F0F0]">
              <div className="h-6 bg-gray-200 rounded w-16 mx-auto"></div>
            </td>
            <td className="px-5 py-2">
              <div className="flex items-center justify-center gap-1.5">
                <div className="h-8 w-8 bg-gray-200 rounded-[10px]"></div>
                <div className="h-8 w-8 bg-gray-200 rounded-[10px]"></div>
                <div className="h-8 w-8 bg-gray-200 rounded-[10px]"></div>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)

function TestList() {
  const [data, setData] = useState([])
  const [pdfData, setPdfData] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [searchTerm, setSearchTerm] = useState('')
  const [entriesPerPage, setEntriesPerPage] = useState('100')
  const [currentPage, setCurrentPage] = useState(1)
  const [statusModalOpen, setStatusModalOpen] = useState(false)
  const [statusModalAction, setStatusModalAction] = useState(null)
  const [deleteModalOpen, setDeleteModalOpen] = useState(false)
  const [testToDelete, setTestToDelete] = useState(null)
  const [showAddTestModal, setShowAddTestModal] = useState(false)
  const [showEditTestModal, setShowEditTestModal] = useState(false)
  const [selectedTestId, setSelectedTestId] = useState(null)
  const navigate = useNavigate()

  useEffect(() => {
    const fetchData = async () => {
      try {
        await getTests()
      } catch (error) {
        console.error('Error loading data:', error)
        setIsLoading(false)
      }
    }
    fetchData()
  }, [])

  // Filter data based on search term
  const filteredData = data.filter(
    (item) =>
      item.test_code?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.test_title?.toLowerCase().includes(searchTerm.toLowerCase())
  )

  // Sort filteredData by createdAt in ascending order (oldest first)
  const sortedData = [...filteredData].sort((a, b) => {
    const dateA = new Date(a.createdAt)
    const dateB = new Date(b.createdAt)
    return dateA - dateB
  })

  // Pagination logic
  const indexOfLastEntry = currentPage * parseInt(entriesPerPage)
  const indexOfFirstEntry = indexOfLastEntry - parseInt(entriesPerPage)
  const currentEntries = sortedData.slice(indexOfFirstEntry, indexOfLastEntry)
  const totalPages = Math.ceil(filteredData.length / parseInt(entriesPerPage))

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber)
  }

  const handleStatusToggle = (id, currentStatus) => {
    setStatusModalAction({ id, type: currentStatus ? 'block' : 'unblock' })
    setStatusModalOpen(true)
  }

  const handleStatusModalConfirm = async () => {
    if (statusModalAction) {
      if (statusModalAction.type === 'block') {
        await blockTest(statusModalAction.id)
      } else {
        await unblockTest(statusModalAction.id)
      }
    }
    setStatusModalOpen(false)
    setStatusModalAction(null)
  }

  const handleStatusModalCancel = () => {
    setStatusModalOpen(false)
    setStatusModalAction(null)
  }

  const handleDeleteClick = (id) => {
    setTestToDelete(id)
    setDeleteModalOpen(true)
  }

  const handleDeleteConfirm = async () => {
    if (testToDelete) {
      await deleteTest(testToDelete)
    }
    setDeleteModalOpen(false)
    setTestToDelete(null)
  }

  const handleDeleteCancel = () => {
    setDeleteModalOpen(false)
    setTestToDelete(null)
  }

  const deleteTest = async (id) => {
    if (window.confirm('Are you sure you want to delete test?')) {
      const response = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}delete_test/${id}`
      )
      toast.success(response.data)
      getTests()
    }
  }

  const blockTest = async (id) => {
    if (window.confirm('Are you sure you wnat to Deactivate Test?')) {
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}block_test/${id}`
      )
      toast.success(response.data)
      getTests()
    }
  }

  useEffect(() => {
    if (pdfData.length > 0) {
      handleDownload()
    }
  }, [pdfData])

  const handleDownload = async () => {
    // Create a new instance of jsPDF
    const doc = new jsPDF()

    const divToHide = document.getElementById('pdf-content')
    divToHide.style.display = 'block'

    // Select the HTML element containing the content you want to include in the PDF
    const contentElement = document.getElementById('pdf-content')
    let opts = {
      margin: 0.3,
      filename: 'example.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      pagebreak: { before: '#page-break' },
      html2canvas: {
        scale: 1,
        y: 0,
        scrollY: 0,
        useCors: true,
        dpi: 192,
        bottom: 0,
        letterRendering: true,
      },
      jsPDF: {
        unit: 'in',
        format: 'letter',
        orientation: 'portrait',
      },
    }
    try {
      html2PDF()
        .set(opts)
        .from(contentElement)
        .toPdf()
        .save('example.pdf')
        .then((res) => {
          divToHide.style.display = 'none'
          setPdfData([])
        })
    } catch (error) {
      divToHide.style.display = 'none'
      setPdfData([])
    }
  }

  const unblockTest = async (id) => {
    if (window.confirm('Are you sure you want to Activate Test?')) {
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}unblock_test/${id}`
      )
      toast.success(response.data)
      getTests()
    }
  }

  const getTests = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}getalltests`
      )
      if (response.status === 200) {
        setData(response.data)
      }
    } catch (error) {
      toast.error('Failed to fetch tests')
    } finally {
      setIsLoading(false)
    }
  }

  const getSActtest = async (item) => {
    try {
      const response = await apiService().get(`sedit_test/${item._id}`)
      if (response.status === 200) {
        const questions = response.data.data.questions_and_answers
        generatePDF(questions, item.test_title)
      }
    } catch (error) {
      console.error('Error fetching test data:', error)
      toast.error('Failed to generate PDF')
    }
  }

  const generatePDF = (questions, testTitle) => {
    const doc = new jsPDF()

    // Add title
    doc.setFontSize(16)
    doc.text(testTitle, 20, 20)

    // Add questions
    let yPosition = 40
    questions.forEach((question, index) => {
      // Add question number and text
      doc.setFontSize(12)
      doc.text(`Question ${index + 1}:`, 20, yPosition)
      yPosition += 10
      doc.setFontSize(10)

      // Split question text into multiple lines if needed
      const splitText = doc.splitTextToSize(question.question || '', 170)
      doc.text(splitText, 20, yPosition)
      yPosition += splitText.length * 7

      // Add answer
      doc.text(`Answer: ${question.answer || ''}`, 20, yPosition)
      yPosition += 15

      // Add page break if needed
      if (yPosition > 270) {
        doc.addPage()
        yPosition = 20
      }
    })

    // Save the PDF
    doc.save(`${testTitle.replace(/\s+/g, '_')}_questions.pdf`)
  }

  return (
    <section className="bg-white border rounded-[10px] border-[#F0F0F0]">
      {/* Header Controls Section */}
      <div className="justify-between items-center border border-[#F0F0F0] flex w-full gap-[40px_100px] font-medium leading-[1.2] flex-wrap bg-white px-5 py-4 rounded-t-[10px]">
        <h2 className="text-lg text-[#030303] font-bold">ACT Tests List</h2>
        <div className="self-stretch flex min-w-60 items-center gap-2.5 text-xs text-[#535862] flex-wrap w-[750px] my-auto max-md:max-w-full">
          <div className="self-stretch flex items-center gap-[9px] my-auto">
            <div className="text-[#535862] self-stretch my-auto">
              Show Entries
            </div>
            <div className="self-stretch flex items-center gap-2 whitespace-nowrap text-center w-[90px] my-auto relative">
              <div className="justify-center items-stretch border border-[#F0F0F0] self-stretch flex w-[90px] flex-col bg-white my-auto px-2.5 py-[9px] rounded-[10px] border-solid relative">
                <select
                  className="text-[#535862] self-stretch my-auto bg-transparent outline-none appearance-none w-full pr-6"
                  value={entriesPerPage}
                  onChange={(e) => {
                    setEntriesPerPage(e.target.value)
                    setCurrentPage(1)
                  }}
                  aria-label="Entries per page"
                  style={{
                    WebkitAppearance: 'none',
                    MozAppearance: 'none',
                    appearance: 'none',
                  }}
                >
                  <option value="100">100</option>
                  <option value="200">200</option>
                  <option value="500">500</option>
                  <option value="1000">1000</option>
                </select>
                <div className="pointer-events-none absolute right-3 top-1/2 transform -translate-y-1/2 flex w-4 h-4">
                  <svg width="16" height="16" fill="none" viewBox="0 0 16 16">
                    <path
                      d="M4 6l4 4 4-4"
                      stroke="#535862"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div className="self-stretch min-w-60 text-sm font-normal grow shrink w-[356px] my-auto rounded-[0px_0px_0px_0px]">
            <div className="flex items-center gap-1 border border-[#F0F0F0] bg-white px-3 py-2 rounded-md w-full focus-within:border-[#DE3C7D]">
              <svg width="16" height="16" fill="none" viewBox="0 0 16 16">
                <circle
                  cx="7.5"
                  cy="7.5"
                  r="6.5"
                  stroke="#535862"
                  strokeWidth="1.5"
                />
                <path
                  d="M14 14l-2.5-2.5"
                  stroke="#535862"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
              </svg>
              <input
                type="text"
                placeholder="Search test..."
                className="text-[#535862] bg-transparent outline-none border-none w-full"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
          <Link
            to="#"
            onClick={(e) => {
              e.preventDefault()
              setShowAddTestModal(true)
            }}
            className="justify-center items-stretch self-stretch flex flex-col text-white text-center grow shrink w-[140px] bg-[#DE3C7D] my-auto p-2.5 rounded-md flex-shrink-0 hover:bg-[#c8356f] transition-colors"
          >
            <div className="flex w-full gap-1 items-center justify-center">
              <div className="text-white">Add New ACT Test</div>
              <div className="flex w-3.5 shrink-0 h-3.5">
                <svg width="16" height="16" fill="none" viewBox="0 0 16 16">
                  <path
                    d="M8 3.333v9.334M3.333 8h9.334"
                    stroke="#fff"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
            </div>
          </Link>
        </div>
      </div>
      {/* End Header Controls Section */}
      <div className="overflow-x-auto">
        {isLoading ? (
          <TableSkeleton />
        ) : (
          <>
            <table className="w-full">
              <thead className="bg-neutral-50">
                <tr>
                  <th className="text-sm text-[#535862] font-medium text-center border w-[60px] px-2 py-3.5 border-[#F0F0F0]">
                    S.No
                  </th>
                  <th className="text-sm text-[#535862] font-medium text-center border w-28 px-2 py-3.5 border-[#F0F0F0]">
                    Test Code
                  </th>
                  <th className="text-sm text-[#535862] font-medium text-center border w-56 px-2 py-3.5 border-[#F0F0F0]">
                    Test Name
                  </th>
                  <th className="text-sm text-[#535862] font-medium text-center border w-64 px-4 py-3.5 border-[#F0F0F0]">
                    Dates
                  </th>
                  <th className="text-sm text-[#535862] font-medium text-center border w-32 px-5 py-3.5 border-[#F0F0F0]">
                    Status
                  </th>
                  <th className="text-sm text-[#535862] font-medium text-center border w-32 px-5 py-3.5 border-[#F0F0F0]">
                    Actions
                  </th>
                  <th className="text-sm text-[#535862] font-medium text-center border w-40 px-5 py-3.5 border-[#F0F0F0]">
                    Import/Export
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentEntries.length > 0 ? (
                  currentEntries.map((item, index) => (
                    <tr key={item._id} className="border border-[#F0F0F0]">
                      <td className="text-center border px-2 py-2 border-[#F0F0F0]">
                        {String(indexOfFirstEntry + index + 1).padStart(2, '0')}
                      </td>
                      <td className="text-center border px-2 py-2 border-[#F0F0F0]">
                        {item.test_code}
                      </td>
                      <td className="text-center border px-2 py-2 border-[#F0F0F0]">
                        {item.test_title}
                      </td>
                      <td className="text-center border px-4 py-2 border-[#F0F0F0]">
                        {item.start_date || item.end_date ? (
                          <>
                            {item.start_date
                              ? format(
                                  new Date(item.start_date),
                                  'MMM dd, yyyy'
                                )
                              : ''}
                            {item.start_date && item.end_date ? ' - ' : ''}
                            {item.end_date
                              ? format(new Date(item.end_date), 'MMM dd, yyyy')
                              : ''}
                          </>
                        ) : (
                          '—'
                        )}
                      </td>
                      <td className="text-center border px-5 py-2 border-[#F0F0F0]">
                        <div className="flex justify-center">
                          <StatusToggle
                            initialStatus={item.status}
                            onChange={() =>
                              handleStatusToggle(item._id, item.status)
                            }
                          />
                        </div>
                      </td>
                      <td className="text-center border px-5 py-2 border-[#F0F0F0]">
                        <div className="flex items-center justify-center gap-1.5">
                          <Link
                            to={`/nacttestpage/${item._id}`}
                            title="Start ACT Test"
                          >
                            <button className="border bg-neutral-50 p-2 rounded-[10px] border-[#F0F0F0] hover:bg-neutral-100 transition-colors">
                              <TaskSquareIcon className="text-[#535862]" />
                            </button>
                          </Link>
                          <button
                            onClick={() => {
                              setSelectedTestId(item._id)
                              setShowEditTestModal(true)
                            }}
                            className="border bg-neutral-50 p-2 rounded-[10px] border-[#F0F0F0] hover:bg-neutral-100 transition-colors"
                            title="Edit ACT Test"
                          >
                            <span className="text-[#535862]">
                              <EditIcon />
                            </span>
                          </button>
                          <button
                            title="Delete ACT Test"
                            className="border bg-[rgba(233,0,4,0.10)] p-2 rounded-[10px] border-[rgba(233,0,4,0.20)] hover:bg-[rgba(233,0,4,0.15)] transition-colors"
                            onClick={() => handleDeleteClick(item._id)}
                          >
                            <span className="text-[#E90004]">
                              <DeleteIcon />
                            </span>
                          </button>
                        </div>
                      </td>
                      <td className="text-center border px-5 py-2 border-[#F0F0F0]">
                        <div className="flex items-center justify-center gap-1.5">
                          <Link
                            to={`/acttestimport/${item._id}`}
                            title="ACT Key Import"
                          >
                            <button className="border bg-neutral-50 p-2 rounded-[10px] border-[#F0F0F0] hover:bg-neutral-100 transition-colors">
                              <ImportIcon className="text-[#535862]" />
                            </button>
                          </Link>
                          <Link
                            to={`/acttestscale/${item._id}`}
                            title="ACT Scale Import"
                          >
                            <button className="border bg-neutral-50 p-2 rounded-[10px] border-[#F0F0F0] hover:bg-neutral-100 transition-colors">
                              <ImportIcon className="text-[#535862]" />
                            </button>
                          </Link>
                          <Link
                            to={`/actstestimport/${item._id}`}
                            title="ACT Test Import"
                          >
                            <button className="border bg-neutral-50 p-2 rounded-[10px] border-[#F0F0F0] hover:bg-neutral-100 transition-colors">
                              <ImportIcon className="text-[#535862]" />
                            </button>
                          </Link>
                          <button
                            title="PDF Download"
                            className="border bg-neutral-50 p-2 rounded-[10px] border-[#F0F0F0] hover:bg-neutral-100 transition-colors"
                            onClick={() => getSActtest(item)}
                          >
                            <ExportIcon className="text-[#535862]" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7} className="text-center py-8 text-[#535862]">
                      No tests found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {/* Pagination Controls */}
            {filteredData.length > 0 && (
              <div className="flex justify-between items-center mt-4 px-4">
                <div className="text-sm text-[#535862]">
                  Showing {indexOfFirstEntry + 1} to{' '}
                  {Math.min(indexOfLastEntry, filteredData.length)} of{' '}
                  {filteredData.length} entries
                </div>
                <div className="flex gap-2">
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="px-3 py-1 border border-[#F0F0F0] rounded-md disabled:opacity-50"
                  >
                    Previous
                  </button>
                  {[...Array(totalPages)].map((_, index) => (
                    <button
                      key={index + 1}
                      onClick={() => handlePageChange(index + 1)}
                      className={`px-3 py-1 border border-[#F0F0F0] rounded-md ${
                        currentPage === index + 1
                          ? 'bg-[#DE3C7D] text-white'
                          : ''
                      }`}
                    >
                      {index + 1}
                    </button>
                  ))}
                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="px-3 py-1 border border-[#F0F0F0] rounded-md disabled:opacity-50"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </div>
      {/* Status Modal */}
      <ConfirmModal
        open={statusModalOpen}
        onConfirm={handleStatusModalConfirm}
        onCancel={handleStatusModalCancel}
        title={
          statusModalAction?.type === 'block'
            ? 'Deactivate Test'
            : 'Activate Test'
        }
        message={`Are you sure you want to ${
          statusModalAction?.type === 'block' ? 'deactivate' : 'activate'
        } this test?`}
      />
      {/* Delete Modal */}
      <ConfirmModal
        open={deleteModalOpen}
        onConfirm={handleDeleteConfirm}
        onCancel={handleDeleteCancel}
        title="Delete Test"
        message="Are you sure you want to delete this test?"
      />
      {showAddTestModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <AddTest
            onClose={() => setShowAddTestModal(false)}
            onSuccess={() => {
              setShowAddTestModal(false)
              getTests()
            }}
          />
        </div>
      )}
      {showEditTestModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <EditTest
            testId={selectedTestId}
            onClose={() => setShowEditTestModal(false)}
            onSuccess={() => {
              setShowEditTestModal(false)
              getTests()
            }}
          />
        </div>
      )}
      <ToastContainer />
      {/* ...existing PDF content... */}
    </section>
  )
}
export default TestList
